import React from 'react'
import numeral from 'numeral'
import PropTypes from 'prop-types'

function ItemPricing({ titleIsHidden, pricing }) {
  let wrapperClassName = 'content-box__price'

  if (titleIsHidden) {
    wrapperClassName += ' title-is-hidden'
  }

  if (pricing.discount !== 0) {
    wrapperClassName += ' is-discounted-price'
  }

  if (pricing.discount === 0) {
    if (pricing.originalPrice === 0) {
      return <div className={wrapperClassName}>Free</div>
    }
    return (
      <div className={wrapperClassName}>
        {numeral(pricing.price).format('$0.00')}
      </div>
    )
  }
  return (
    <div className={wrapperClassName}>
      <div className="content-box__sale-off">
        {numeral(pricing.price).format('$0.00')}
      </div>
      <div className="content-box__original-price">
        {numeral(pricing.originalPrice).format('$0.00')}
      </div>
      <div className="content-box__discount">
        -{numeral(pricing.discount).format('0%')}
      </div>
    </div>
  )
}

ItemPricing.propTypes = {
  titleIsHidden: PropTypes.bool.isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.number.isRequired,
    originalPrice: PropTypes.number.isRequired,
  }).isRequired,
}

export default ItemPricing
